import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { IMPACT_PERCEPTION } from '../../lib/schema.js';

PerceptionFilter.defaultProps = {
  selectedPerceptions: [],
};

function PerceptionFilter({ selectedPerceptions, navigateAction }) {
  const selectedCount = selectedPerceptions.length;

  const handleSelect = useCallback(
    (perception) =>
      navigateAction({
        perceptions: perception ? xor(selectedPerceptions, [perception]) : [],
      }),
    [selectedPerceptions]
  );

  const renderMenuItem = useCallback(
    (perception) => (
      <React.Fragment key={perception}>
        <MenuItem
          active={selectedPerceptions.includes(perception)}
          eventKey={perception}
          onSelect={handleSelect}
        >
          {perception}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedPerceptions]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Perception</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="perception-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {IMPACT_PERCEPTION.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default PerceptionFilter;
